import React, { useState, useEffect } from 'react';
import { fetchAllUsers, sendMessage } from './ChatAPI';

const NewChatModal = ({ onClose, onCreated }) => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [query, setQuery] = useState('');
    const [selected, setSelected] = useState([]);
    const [groupTitle, setGroupTitle] = useState('');
    const [firstMessage, setFirstMessage] = useState('');
    const [sending, setSending] = useState(false);

    useEffect(() => {
        fetchAllUsers().then(res => {
            if (res.success) setUsers(res.data);
        }).finally(() => setLoading(false));
    }, []);

    const filtered = users.filter(u =>
        !query || u.name.toLowerCase().includes(query.toLowerCase())
    );

    const toggleSelect = (u) => {
        setSelected(prev => prev.find(x => x.id === u.id)
            ? prev.filter(x => x.id !== u.id)
            : [...prev, u]);
    };

    const handleStart = async () => {
        if (selected.length === 0) { alert('Select at least one person'); return; }
        if (!firstMessage.trim()) { alert('Write a first message'); return; }
        setSending(true);
        try {
            const isGroup = selected.length > 1;
            const res = await sendMessage({
                recipient_ids: selected.map(u => u.id),
                body: firstMessage.trim(),
                thread_type: isGroup ? 'group' : 'dm',
                title: isGroup ? (groupTitle.trim() || `Group of ${selected.length + 1}`) : ''
            });

            if (res.success) {
                onCreated(res.thread_id, {
                    thread_id: res.thread_id,
                    thread_key: res.thread_key,
                    thread_type: isGroup ? 'group' : 'dm',
                    title: isGroup ? (groupTitle.trim() || `Group of ${selected.length + 1}`) : '',
                    members: [{ id: parseInt(localStorage.getItem('id') || '0', 10), name: 'You' }, ...selected],
                    unread_count: 0
                });
            } else {
                alert(res.error || 'Failed');
            }
        } catch (err) {
            console.error(err);
            alert('Failed to start chat');
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="skc-newchat-overlay" onClick={onClose}>
            <div className="skc-newchat-modal" onClick={e => e.stopPropagation()}>
                <header className="skc-newchat-head">
                    <h3>New conversation</h3>
                    <button onClick={onClose} className="skc-newchat-close">×</button>
                </header>

                {selected.length > 0 && (
                    <div className="skc-newchat-chips">
                        {selected.map(u => (
                            <span key={u.id} className="skc-newchat-chip">
                                {u.name}
                                <button onClick={() => toggleSelect(u)}>×</button>
                            </span>
                        ))}
                    </div>
                )}

                {selected.length > 1 && (
                    <input
                        className="skc-newchat-input"
                        placeholder="Group name (optional)"
                        value={groupTitle}
                        onChange={e => setGroupTitle(e.target.value)}
                    />
                )}

                <input
                    className="skc-newchat-input"
                    placeholder="Search people…"
                    value={query}
                    onChange={e => setQuery(e.target.value)}
                />

                <div className="skc-newchat-list">
                    {loading && <div className="skc-newchat-empty">Loading users…</div>}
                    {!loading && filtered.length === 0 && <div className="skc-newchat-empty">No users found</div>}
                    {filtered.map(u => {
                        const isSelected = !!selected.find(x => x.id === u.id);
                        return (
                            <button
                                key={u.id}
                                className={`skc-newchat-user ${isSelected ? 'is-selected' : ''}`}
                                onClick={() => toggleSelect(u)}
                            >
                                <div className="skc-newchat-user-avatar">
                                    {u.image ? <img src={u.image} alt={u.name} /> : <span>{u.name.charAt(0)}</span>}
                                </div>
                                <div className="skc-newchat-user-meta">
                                    <strong>{u.name}</strong>
                                    <small>{u.usertype}</small>
                                </div>
                                <div className="skc-newchat-check">{isSelected ? '✓' : ''}</div>
                            </button>
                        );
                    })}
                </div>

                <textarea
                    className="skc-newchat-textarea"
                    placeholder="Write your first message…"
                    value={firstMessage}
                    onChange={e => setFirstMessage(e.target.value)}
                    rows={3}
                />

                <footer className="skc-newchat-foot">
                    <button className="skc-newchat-cancel" onClick={onClose}>Cancel</button>
                    <button
                        className="skc-newchat-start"
                        onClick={handleStart}
                        disabled={sending || selected.length === 0 || !firstMessage.trim()}
                    >
                        {sending ? 'Starting…' : 'Start chat'}
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default NewChatModal;